import { CanDeactivate } from '@angular/router';
import { Injectable } from '@angular/core';

export interface ComponentCanDeactivate {
  canDeactivate: () => Promise<boolean>;
}

@Injectable()
export class PendingChangesGuard implements CanDeactivate<ComponentCanDeactivate> {

  constructor() { }

  async canDeactivate(component: ComponentCanDeactivate, currentRoute: any): Promise<boolean> {
    const x = await component.canDeactivate();
    return x;
  }
}